const zeroqtyreducers = (state = true, action) => {
    switch (action.type) {
        case 'SET_ZERO_QTY':
            return !state;
        default:
            return state;
    }
}
export default zeroqtyreducers;
